<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      :short-title="this.$THEME.webTitle"
      :title="this.$THEME.webTitle"
    >
      <template slot="links">
        <sidebar-item
          v-if="isMember() || (isAdmin() && !this.$THEME.hidePOSFromAdmin)"
          class=""
          :link="{
            name: 'POS',
            icon:
              'fas fa-cash-register ' +
              (this.$THEME.primaryColor ? '' : 'text-blue'),
            color: this.$THEME.primaryColor,
            path: '/pos',
          }"
        />
        <!-- IT-3404 — ประกาศข่าวสาร (below md only; desktop has it in the top navbar) -->
        <li v-if="showAnnouncement" class="nav-item d-md-none">
          <router-link to="/announcements" class="nav-link" @click.native="toggleSidebar">
            <i
              :class="'fas fa-bullhorn ' + (this.$THEME.primaryColor ? '' : 'text-orange')"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span class="nav-link-text">ประกาศข่าวสาร</span>
            <span
              v-if="annState.unread"
              class="pop-ann-count ml-2"
              :aria-label="'ยังไม่ได้อ่าน ' + annState.unread + ' รายการ'"
            >{{ annState.unread > 99 ? "99+" : annState.unread }}</span>
          </router-link>
        </li>
        <base-dropdown
          class="nav-item nav-dropdown"
          v-if="isMember() || isAdmin()"
        >
          <a slot="title" class="nav-link" role="button">
            <i
              :class="
                'fas fa-folder-open ' +
                (this.$THEME.primaryColor ? '' : 'text-green')
              "
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span class="nav-link-text">การขายสินค้า</span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
          <div class="dropdown-header">
            <h6 class="text-overflow m-0">การขายสินค้า</h6>
          </div>
          <sidebar-item
            :link="{
              name: 'สรุปข้อมูลยอดขาย',
              icon: 'fa fa-list-alt',
              color: this.$THEME.primaryColor,
              path: '/dashboard',
            }"
          />
          <sidebar-item
            :link="{
              name: 'ประวัติยกเลิกรายการ',
              icon: 'fa fa-trash text-red',
              color: this.$THEME.primaryColor,
              path: `/historycancel`,
            }"
          />
        </base-dropdown>
        <sidebar-item
            v-if="isMember()
            || isAdmin()
            || isSuperAdmin()
            || (isShippop()
                && auth0RoleMenuLayout('tracking')
            )"
            :link="{
                name: 'ติดตามสถานะพัสดุ',
                icon:
                'fas fa-truck-loading ' + (this.$THEME.primaryColor ? '' : 'text-indigo'),
                color: this.$THEME.primaryColor,
                path: '/tracking',
            }"
        />
        <base-dropdown
          class="nav-item nav-dropdown"
          v-if="isAdmin()
            || isSuperAdmin()
            || (isShippop()
                && auth0RoleMenuLayout('transports')
            )"
        >
          <a slot="title" class="nav-link" role="button">
            <i
              class="fas fa-truck"
              :class="this.$THEME.primaryColor ? '' : 'text-yellow'"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span class="nav-link-text">จัดการขนส่ง</span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
          <router-link to="/transports" class="dropdown-item">
            <span class="mr-2">
              <i class="fas fa-bicycle"></i>
            </span>
            <span>
              ขนส่งในประเทศ
            </span>
          </router-link>
          <router-link to="/transports/inter" class="dropdown-item" v-if="isShippop() || isSuperAdmin() || permission.interParcelService">
            <span class="mr-2">
              <i class="fas fa-plane"></i>
            </span>
            <span>
              ขนส่งต่างประเทศ
            </span>
          </router-link>
        </base-dropdown>
        <!-- <sidebar-item
            v-if="isAdmin()
            || isSuperAdmin()
            || (isShippop()
                && auth0RoleMenuLayout('transports')
            )"
            :link="{
                name: 'จัดการขนส่ง',
                icon:
                'fas fa-truck ' + (this.$THEME.primaryColor ? '' : 'text-yellow'),
                color: this.$THEME.primaryColor,
                path: '/transports',
            }"
        /> -->
        <sidebar-item
          v-if="isAdmin()"
          :link="{
            name: 'จัดการสินค้า',
            icon:
              'fas fa-shopping-cart ' +
              (this.$THEME.primaryColor ? '' : 'text-purple'),
            color: this.$THEME.primaryColor,
            path: '/product',
          }"
        />
        <sidebar-item
          v-if="isAdmin()"
          :link="{
            name: 'จัดการบริการเสริม',
            icon:
              'fas fa-globe ' +
              (this.$THEME.primaryColor ? '' : 'text-default'),
            color: this.$THEME.primaryColor,
            path: '/categoryservice',
          }"
        />
        <sidebar-item
            v-if="isAdmin() || isShippop() && auth0RoleMenuLayout('usersmanage')"
            :link="{
                name: setNameManageUser(),
                icon:
                'fas fa-user-cog ' +
                (this.$THEME.primaryColor ? '' : 'text-primary'),
                color: this.$THEME.primaryColor,
                path: '/usersmanage',
            }"
        />
        <sidebar-item
            v-if="isSuperAdmin()
            || (isShippop()
                && auth0RoleMenuLayout('agentmanage')
            )"
            :link="{
                name: 'จัดการตัวแทนจำหน่าย (SuperAdmin)',
                icon:
                'fas fa-users ' +
                (this.$THEME.primaryColor ? '' : 'text-warning'),
                color: this.$THEME.primaryColor,
                path: (isSuperAdmin()) ? `/agent/${this.$USER_LOGIN.get().details.sub}` :'/agentmanage',
            }"
        />
        <sidebar-item
            v-if="
            isSuperAdmin()
            || (isShippop()
                && auth0RoleMenuLayout('brancemanage')
            )"
            :link="{
                name: setNameManageShop(),
                icon:
                'fas fa-store ' + (this.$THEME.primaryColor ? '' : 'text-red'),
                color: this.$THEME.primaryColor,
                path: '/brancemanage',
            }"
        />
        <sidebar-item
          v-if="isAdmin()"
          :link="{
            name: 'จัดการร้านค้า',
            icon:
              'fas fa-store ' + (this.$THEME.primaryColor ? '' : 'text-red'),
            color: this.$THEME.primaryColor,
            path: '/branceedit/',
          }"
        />
        <sidebar-item
            v-if="(
                isShippop()
                && auth0RoleMenuLayout('fakecustomer')
            )"
            :link="{
                name: 'จัดการลูกค้าหน้าสาขา',
                icon:
                'fas fa-user ' +
                (this.$THEME.primaryColor ? '' : 'text-green'),
                color: this.$THEME.primaryColor,
                path: '/fakecustomer',
            }"
        />
        <sidebar-item
            v-if="(
                isShippop()
                && auth0RoleMenuLayout('usershop')
            )"
            :link="{
                name: 'จัดการสมาชิก (' + this.$THEME.webTitle + ')',
                icon:
                'fas fa-address-book ' +
                (this.$THEME.primaryColor ? '' : 'text-purple'),
                color: this.$THEME.primaryColor,
                path: '/usershop',
            }"
        />
        <sidebar-item
            v-if="(
                isShippop()
                && auth0RoleMenuLayout('waiveinvoice')
            )"
            :link="{
                name: 'ยกเว้นค่าขนส่งในใบแจ้งหนี้',
                icon:
                'fas fa-file-invoice ' +
                (this.$THEME.primaryColor ? '' : 'text-yellow'),
                color: this.$THEME.primaryColor,
                path: '/waiveinvoice',
            }"
        />
        <sidebar-item
          v-if="isMember() || isAdmin()"
          :link="{
            name: 'จัดการใบนำส่งพัสดุ',
            icon:
              'fas fa-file-signature ' +
              (this.$THEME.primaryColor ? '' : 'text-warning'),
            color: this.$THEME.primaryColor,
            path: '/exportdelivery',
          }"
        />
        <sidebar-item
          v-if="isMember() || isAdmin()"
          :link="{
            name: 'จัดการลูกค้า',
            icon:
              'fas fa-address-card ' +
              (this.$THEME.primaryColor ? '' : 'text-yellow'),
            color: this.$THEME.primaryColor,
            path: '/membershop',
          }"
        />
        <base-dropdown
          class="nav-item nav-dropdown"
          v-if="isMember() || isAdmin()"
        >
          <a slot="title" class="nav-link" role="button">
            <i
              class="fas fa-dolly-flatbed"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span class="nav-link-text">จัดการขนส่งเข้ารับ</span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
<!--          <router-link to="/manage/callconfig" class="dropdown-item">-->
<!--            <i class="fas fa-truck" style="color:#63b7ff;"></i> <span>ตั้งค่าการเรียกรถเข้ารับ</span>-->
<!--          </router-link>-->
          <router-link to="/manage/driver" class="dropdown-item">
            <i class="fas fa-shipping-fast" style="color:#63b7ff;"></i> <span>รายการเข้ารับ</span>
          </router-link>
          <router-link to="/flefixparcel" class="dropdown-item">
            <img
              :src="
                this.$THEME.replaceUpdateFlashMenu
                  ? this.$THEME.replaceFlashIcon
                  : 'img/courier_icons/FLE.jpg'
              "
              class="fle-icon"
            />
            <span
              >{{
                this.$THEME.replaceUpdateFlashMenu || "Flash Express"
              }}
              อัพเดทน้ำหนัก</span
            >
          </router-link>

        </base-dropdown>
        <base-dropdown class="nav-item nav-dropdown" v-if="isSuperAdmin()">
          <a slot="title" class="nav-link" role="button">
            <!-- <i class="fas fa-folder-open text-blue"></i> -->
            <i class="fas fa-clipboard-check text-blue"></i>
            <span class="nav-link-text">ระบบยืนยันตน</span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
          <div class="dropdown-header">
            <h6 class="text-overflow m-0">เมนูยืนยันตัวตน</h6>
          </div>
          <router-link to="/confirmCommissionSPAdmin" class="dropdown-item">
            <i class="fas fa-id-card"></i>
            <span>ตรวจสอบลงทะเบียนคอมมิชชั่น</span>
          </router-link>
          <router-link to="/resgisterCommission" class="dropdown-item">
            <i class="fas fa-coins"></i>
            <span>ลงทะเบียนคอมมิชชั่น</span>
          </router-link>
        </base-dropdown>
        <MenuWallet v-if="$WALLET.status !== null || isMaster() || isShippop()" />
        <base-dropdown class="nav-item nav-dropdown"
            v-if="(
                isShippop()
                && auth0RoleMenuLayout('accounting')
            )"
        >
          <a slot="title" class="nav-link" role="button">
            <!-- <i class="fas fa-folder-open text-blue"></i> -->
            <i
              :class="
                'fas fa-landmark ' +
                (this.$THEME.primaryColor ? '' : 'text-warning')
              "
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span class="nav-link-text">จัดการข้อมูลบัญชี</span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
          <div class="dropdown-header">
            <h6 class="text-overflow m-0">เกี่ยวกับ COD</h6>
          </div>
          <router-link to="/manage/cod" class="dropdown-item">
            <i
              class="fas fa-people-carry"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span>จัดการรายการ COD</span>
          </router-link>
          <router-link to="/membercod" class="dropdown-item">
            <i
              class="fas fa-people-carry"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span>รายงานลูกค้า</span>
          </router-link>
          <div class="dropdown-header">
            <h6 class="text-overflow m-0">เกี่ยวกับคอมมิชชั่น</h6>
          </div>
          <router-link to="/shop/commission" class="dropdown-item">
            <i
              class="fas fa-clipboard-check"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span>รายงานร้านค้า</span>
          </router-link>
          <router-link to="/superadmin/commission" class="dropdown-item">
            <i
              class="fas fa-id-badge"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span>รายงาน SuperAdmin</span>
          </router-link>
        </base-dropdown>
        <base-dropdown class="nav-item nav-dropdown">
          <a slot="title" class="nav-link" role="button">
            <i
              :class="
                'fas fa-folder-open ' +
                (this.$THEME.primaryColor ? '' : 'text-green')
              "
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span class="nav-link-text">รายงาน</span>
            <i class="fas fa-caret-down pl-2"></i>
            <b-badge variant="danger" pill v-if="this.$THEME.failReport && countProblem > 0">{{countProblem}}</b-badge>
          </a>
          <div class="dropdown-header">
            <h6 class="text-overflow m-0">สรุปรายงาน</h6>
          </div>
          <router-link
            to="/reporttransport"
            class="dropdown-item"
            v-if="isMember() || isAdmin()"
          >
            <i
              class="fas fa-archive"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span>พัสดุ</span>
          </router-link>
          <router-link
            to="/reportparcel"
            class="dropdown-item"
            v-if="this.$THEME.failReport && (isMember() || isAdmin() || isSuperAdmin())"
          >
            <i
              class="fas fa-truck-loading"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span>ปัญหาขนส่ง
                <b-badge variant="danger" pill v-if="countProblem > 0">{{countProblem}}</b-badge>
            </span>
          </router-link>
          <router-link
            to="/reportproduct"
            class="dropdown-item"
            v-if="isMember() || isAdmin()"
          >
            <i
              class="fas fa-box-open"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span>สินค้าอื่นๆ</span>
          </router-link>
          <router-link
            to="/reportdropoffshippop"
            class="dropdown-item"
            v-if="(isMember() || isAdmin()) && getStatusServiceDropoffShippop"
          >
            <i
              class="fab fa-dropbox"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span>DROPOFF {{ this.$THEME.webTitle }}</span>
          </router-link>
          <router-link
            to="/reportdelivery"
            class="dropdown-item"
            v-if="isMember() || isAdmin()"
          >
            <i
              class="fas fa-file-contract pl-1"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span>ใบนำส่งพัสดุ</span>
          </router-link>
          <!-- <router-link to="/reportweightover" class="dropdown-item" v-if="$WALLET.status == true && isSuperAdmin()">
                    <i class="fas fa-truck-loading" v-bind:style="{color: this.$THEME.primaryColor}"></i>
                    <span>รายงานพัสดุน้ำหนักเกิน</span>
                </router-link> -->
            <router-link
                to="/reportshippop"
                class="dropdown-item"
                v-if="isAdmin()
                || isSuperAdmin()
                || ( isShippop()
                    && auth0RoleMenuLayout('reportshippop')
                )"
            >
                <i
                    class="fas fa-tachometer-alt"
                    v-bind:style="{ color: this.$THEME.primaryColor }"
                ></i>
                <span>ระบบ {{ this.$THEME.webTitle }}</span>
            </router-link>
            <router-link to="/reportcod" class="dropdown-item"
                v-if="isMember()
                || isAdmin()
                || isSuperAdmin()
                || ( isShippop()
                    && auth0RoleMenuLayout('reportcod')
                )"
            >
                <i
                class="fas fa-hand-holding-usd"
                v-bind:style="{ color: this.$THEME.primaryColor }"
                ></i>
                <span>รายงาน COD</span>
            </router-link>
            <router-link
                to="/reportbrance"
                class="dropdown-item"
                v-if="
                    isSuperAdmin()
                    || isMaster()
                    || ( isShippop()
                        && auth0RoleMenuLayout('reportbrance')
                    )"
            >
                <i
                class="fas fa-chart-line"
                v-bind:style="{ color: this.$THEME.primaryColor }"
                ></i>
                <span>ยอดค้างชำระแต่ละสาขา</span>
            </router-link>
            <router-link
                to="/createbill"
                    class="dropdown-item"
                    v-if="( isShippop()
                        && auth0RoleMenuLayout('createbill')
                    )"
                >
                <i
                class="fas fa-coins"
                v-bind:style="{ color: this.$THEME.primaryColor }"
                ></i>
                <span>เก็บเงินปลายทาง</span>
            </router-link>
            <router-link
                to="/transfer/statement/cod"
                    class="dropdown-item"
                    v-if="( isShippop()
                        && auth0RoleMenuLayout('transferStatement')
                    )"
                >
                <i
                class="fas fa-money-bill"
                v-bind:style="{ color: this.$THEME.primaryColor }"
                ></i>
                <span>รายงานจ่ายเงิน Cod</span>
            </router-link>
          <router-link
            to="/report/dropoff"
            class="dropdown-item"
          v-if="checkServices()"
          >
            <i
              class="fas fa-box"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span>รายงาน Drop-off</span>
          </router-link>
          <router-link
              to="/report/invoice"
              class="dropdown-item"
              v-if="!this.main_use_walletV2 && this.$THEME.menuLayout && this.$THEME.menuLayout.reportInvoice  && (( isAdmin() && $WALLET.status == true ) || isSuperAdmin() || isShippop())"
          >
              <i
                  class="fas fa-file-invoice"
                  v-bind:style="{ color: this.$THEME.primaryColor }"
              ></i>
              <span>ใบแจ้งหนี้ / ใบเสร็จรับเงิน</span>
          </router-link>
          <router-link
              to="/report/receipt"
              class="dropdown-item"
              v-if="
                this.main_use_walletV2 &&
                this.$THEME.menuLayout &&
                this.$THEME.menuLayout.reportReceipt &&
                (( isAdmin() && $WALLET.status == true ) || isShippop())
              "
          >
              <i
                  class="fas fa-file-invoice"
                  v-bind:style="{ color: this.$THEME.primaryColor }"
              ></i>
              <span>ใบเสร็จรับเงิน</span>
          </router-link>
          <router-link
            to="/coupon/coupon-list"
            class="dropdown-item"
            v-if="
              this.main_use_walletV2 &&
              this.main_allow_coupon
            "
          >
              <i class="fa fa-ticket-alt" v-bind:style="{ transform: 'rotate(-45deg)', color: this.$THEME.primaryColor }"></i>
              <span>รายการคูปอง</span>
          </router-link>
        </base-dropdown>
        <!-- line -->
        <base-dropdown
          class="nav-item nav-dropdown"
          v-if="isAdmin() && this.$THEME.serviceName.line"
        >
          <a slot="title" class="nav-link" role="button">
            <i
              class="fas fa-comment-dots"
              v-bind:style="{ color: this.$THEME.primaryColor }"
            ></i>
            <span class="nav-link-text"> เชื่อมต่อ App </span>
            <i class="fas fa-caret-down pl-2"></i>
          </a>
          <router-link to="/setting/line" class="dropdown-item">
            <i
              class="fab fa-line"
              v-bind:style="{ color: '#03c755' , fontSize: '24px' }"
            >
            </i>
            <span>เชื่อมต่อ Line</span>
          </router-link>
        </base-dropdown>
      </template>
      <template
        slot="links-after"
        v-if="createdBy !== 'superadmin' && this.$THEME.contactURL"
      >
        <div class="text-center py-4">
          <a :href="this.$THEME.contactURL" target="_blank">
            หากพบปัญหาด้านระบบติดต่อ
          </a>
        </div>
      </template>
      <template slot="links-after" v-if="this.$THEME.showChangelog">
        <div class="text-center py-4">
          <router-link to="changelog"> ประวัติการอัพเดท </router-link>
        </div>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardNavbar from "./DashboardNavbar.vue"
import MenuWallet from "@/components/custom/menu/MenuWallet"
import LocalStorageManagement from '@/constants/LocalStorageManagement'
import { FadeTransition } from "vue2-transitions"
import { getCountShipmentPending } from "@/axios/failReport.js";
import { auth0RoleMenuLayout } from "@/helpers/auth0"
import { ANNOUNCEMENT_POSITION, announcementState } from "@/axios/announcement.js"
const API_URL = process.env.VUE_APP_API
export default {
  name: 'DashboardLayout',
  components: {
    DashboardNavbar,
    FadeTransition,
    MenuWallet,
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      userLogin: "",
      createdBy: "",
      replaceUpdateFlashMenu: this.$THEME.replaceUpdateFlashMenu || "Flash Express",
      countProblem: 0,
      auth0RoleMenuLayout: auth0RoleMenuLayout,
      permission: {
        interParcelService: false
      },
      annState: announcementState,
    }
  },
  mounted() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    this.createdBy = localStorage.getItem("created_by");
    this.getCountShipmentProblem();
    if (!this.isShippop() && !this.isSuperAdmin())
      this.getShopService();
  },
  methods: {
    setNameManageShop() {
      let name = "จัดการร้านค้า (SP-admin)";
      if (this.isShippop()) {
        name = "จัดการร้านค้า (ทุกสาขา)";
      }
      return name;
    },
    setNameManageUser() {
      let name = "จัดการสมาชิก";
      if (this.isShippop()) {
        name = "จัดการสมาชิก (SHIPPOP)";
      }
      return name;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    isAdmin() {
      return this.userLogin.role === "admin";
    },
    isMember() {
      return this.userLogin.role === "member";
    },
    isSuperAdmin() {
      return this.userLogin.role === "superadmin";
    },
    isMaster() {
      return this.userLogin.role === "master";
    },
    isShippop() {
      return this.userLogin.role === "shippop";
    },
    checkServices(){
        if( this.isSuperAdmin() ) return false
        if( this.isMaster() ) return false
        if( this.isMember() ) return false
        if( this.isShippop() && auth0RoleMenuLayout('reportdropoff')){
            return true
        }
        if (this.$THEME.alwayShowReportDropoff) return true;
        const serviceKey = 'additional_service'
        const check = LocalStorageManagement.get( serviceKey )
        if( !check[serviceKey] )return false
        try{
            return Object.values(check[serviceKey].DROPOFF).some( service =>
            {
                if( service.key === "VRICH_DROPOFF" && this.$THEME.dropoffVRich
                    || service.key === "PANPAN_DROPOFF" && this.$THEME.dropoffPanPan
                    || (service.key === "EASYSHIP_DROPOFF" && this.$THEME.dropoffEasyShip)
                    || (["KERRY_DROPOFF","ORANGE_DROPOFF"].includes(service.key) && this.$THEME.dropoffKerry)
                ){
                    return true
                }else{
                    return service.status === true
                }
            })
        } catch ( err ){
            // eslint-disable-next-line
            console.error( `${this.$options.name}:: ${err}` )
            return false
        }
    },
    async getShopService () {
      // this.busy = true
      let courierPostcodeDetails = JSON.parse(localStorage.getItem('courier_postcode'))
      let cpd = 0
      if (courierPostcodeDetails) {
        cpd = courierPostcodeDetails.version
      } else {
        cpd = 0
      }
      await this.$http
        .get(API_URL + `/shop/${cpd}`, {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let _res = res.data.data
          this.permission.interParcelService = _res.setting.allow_inter_parcel_service
        })
        .catch((err) => {
          console.log('#010', err);
        }).finally(() => {
          // this.busy = false
        });
    },
    async getCountShipmentProblem(){
        await getCountShipmentPending().then( res => {
            this.countProblem = res;
        }).catch(error => {
          //eslint-disable-next-line
          console.error('error Dashboard-->getCountShipmentProblem: ', error)
        });
    }
  },
  computed: {
    // same audience as the POS page (router: /pos and /announcements are member + admin)
    showAnnouncement() {
      return !!ANNOUNCEMENT_POSITION && (this.isMember() || this.isAdmin())
    },
    getStatusServiceDropoffShippop() {
      if (this.userLogin.setting) {
        return this.userLogin.setting.dropoff_shippop;
      }

      return false;
    },
  },
  watch: {
    $route(to, from) {
      if (from.name == "usershop") {
        this.userLogin = JSON.parse(localStorage.getItem("user"));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pop-ann-count {
  display: inline-block;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #e5483f;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}
.fle-icon {
  max-width: 30px;
  box-shadow: 1px 1px 5px 0px #656565;
  height: auto;
  margin-right: 8px;
}
</style>
